import { Post } from '@/shared/services/api/feed/get-post-by-id'
import createMultiSelectionContext from '@/ui/contexts/MultiSelectionContext'

export const {
  MultiSelectionProvider: FeedPostMultiSelectionProvider,
  useMultiSelectionContext: useFeedPostMultiSelectionContext
} = createMultiSelectionContext<number, Post>({ limit: 5 })
